module.exports = __webpack_public_path__ + "static/media/bs_readme-git.2b4ff49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/bs_readme-git.png
// module id = 70
// module chunks = 0